import {
  deleteSearchParams,
  replaceHistoryState,
} from '@/helpers/locationHelpers';
import { useEffect } from 'react';

const RemoveTokenInUrl = () => {
  useEffect(() => {
    const { newPathname } = deleteSearchParams('token');
    replaceHistoryState(newPathname);
  }, []);

  return <></>;
};

export default RemoveTokenInUrl;
